import { IAlertModalPayload } from '@aurelia-toolkit/alert';
import { autoinject, useView, PLATFORM } from 'aurelia-framework';

@autoinject
@useView(PLATFORM.moduleName('./alert-modal.html'))
export class AlertModalDynamik {
  payload: IAlertModalPayload;

  activate(payload: IAlertModalPayload) {
    this.payload = payload;
  }
}
